import script from "./LandingHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingHero.vue?vue&type=script&setup=true&lang=ts"

import "./LandingHero.vue?vue&type=style&index=0&id=ed544a04&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed544a04"]])

export default __exports__